import React from 'react';
import ProgressBar from './ProgessBar';

class InputCard extends React.Component {

    constructor (props) {
        super(props)
        this.state = {selectValue: '', textValue: '', selectedIndex: -1}
    }

    setSelectionInput(id) {
        const val = parseFloat(id)
        this.props.setResponse(val, 1);
        this.setState(() => {
            return {selectValue: id, textValue: '', selectedIndex: val}
        })
    }

    setTextInput (e) {
        const val = parseFloat(e.target.value)
        if (!isNaN(val)) {
            this.props.setResponse(val, 0);
        } else {
            this.props.deleteResponse();
        }
        this.setState(() => {
            return {textValue: e.target.value, selectedIndex: -1}
        })
    }

    stepForward () {
        this.setState({selectValue: '', textValue: '', selectedIndex: -1})
        this.props.stepForward();
    }

    render() {

        const PB = <ProgressBar bgcolor={"#00695c"} completed={Math.ceil((this.props.state.step / this.props.state.source.length).toPrecision(4) * 100)}/>

        const options = [];
        var textField;
        var selectField;

        if (this.props.state.source[this.props.state.step].selectOptions) {
            for (let index = 0; index < this.props.state.source[this.props.state.step].selectOptions.length; index++) {
                options.push(<button type="button" class={index === this.state.selectedIndex ? "btn btn-dark my-1 active" : "btn btn-light my-1"} id={index} onClick={this.setSelectionInput.bind(this, index)}>
                    {this.props.state.source[this.props.state.step].selectOptions[index]}
                </button>)
            }
        }

        if (this.props.state.source[this.props.state.step].inputDescription && (this.props.state.modeSetLocation === -1 || this.props.state.advancedMode === 0 || !this.props.state.source[this.props.state.step].selectDescription || this.props.state.step === this.props.state.modeSetLocation)) {
            textField = <div class="row">
                <div class="col-md-8">
                    <p class="">
                        {this.props.state.source[this.props.state.step].inputDescription}
                    </p>
                </div>
                <div class="col-md-4">
                    <input style={{width:"100%"}} id="textInput" onChange={this.setTextInput.bind(this)} value={this.state.textValue}></input>
                    <label class="mx-1 visually-hidden" for="textInput">{this.props.state.source[this.props.state.step].inputUnit}</label>
                </div>
            </div>
        }

        if (this.props.state.source[this.props.state.step].selectDescription && (this.props.state.modeSetLocation === -1 || this.props.state.advancedMode === 1 || !this.props.state.source[this.props.state.step].inputDescription || this.props.state.step === this.props.state.modeSetLocation)) {
            selectField = <div class="row">
                <div class="col-md-12">
                    <p class="">
                        {this.props.state.source[this.props.state.step].selectDescription}
                    </p>
                </div>
                {options}
            </div>
        }

        return (
            <div class="card">
                <h1 class="text-center m-3">
                    COVID Risk Assessment Tool
                </h1>
                <hr class="m-0"/>
                <p class="text-center my-md-3 font-weight-bold">
                    {this.props.state.source[this.props.state.step].sectionTitle}
                </p>
                <form class="mx-md-5 mx-3 my-md-5">
                    {textField}
                    {selectField}
                </form>
                <div class="row my-4 p-3 text-center">
                    <div class="col-6 my-1">
                        <button class="btn btn-secondary custom-nav-button" onClick={this.props.stepBackward}>Back</button>
                    </div>
                    <div class="col-6 my-1">
                        <button class="btn btn-primary custom-nav-button" onClick={this.stepForward.bind(this)}>Continue</button>
                    </div>
                </div>
                <div class="mx-5 mb-4">
                    {PB}
                </div>
            </div>
        );
    }
}

export default InputCard;
